/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SentCommentRequest, SentCommentState } from "store/modules/complaints/types";

const initialState: SentCommentState = {
    isRequesting: false,
    successPayload: null,
    errors: []
};

const sentCommentSlice = createSlice({
    name: "complaints@sentComment",
    initialState,
    reducers: {
        sentCommentRequest: (
            state,
            action: PayloadAction<SentCommentRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        sentCommentSuccess: (
            state,
            action: PayloadAction<null>
        ): void => {
            state.isRequesting = false;
            state.successPayload = action.payload;
        },
        sentCommentFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        }
    }
});

export const {
    sentCommentRequest,
    sentCommentSuccess,
    sentCommentFailed
} = sentCommentSlice.actions;
export default sentCommentSlice.reducer;
